import React from 'react'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery} from '@packages/apollo-hooks'
import Container from '@packages/justo-parts/lib/components/Container'
import gql from 'graphql-tag'

import Category from './Category'

import styles from './styles.module.css'

export default function Categories(props) {
  const {
    menuId,
    storeId,
    deliverAt,
    categoryId: selectedCategoryId,
    setCategoryId: setSelectedCategoryId,
    hideNotAvailableProducts
  } = props

  const websiteId = useWebsiteId()
  const {categories} = useApolloQuery({
    query: gql`
      query categoriesLayoutCategories($websiteId: ID) {
        categories(websiteId: $websiteId) {
          items {
            _id
            name
          }
        }
      }
    `,
    variables: {websiteId, menuId}
  })

  const selectedCategory = selectedCategoryId
    ? categories.items.find(category => category._id === selectedCategoryId)
    : null
  return (
    <div className={styles.container}>
      <Container>
        {selectedCategory ? (
          <Category
            full
            category={selectedCategory}
            setSelectedCategoryId={setSelectedCategoryId}
            storeId={storeId}
            deliverAt={deliverAt}
            menuId={menuId}
            hideNotAvailableProducts={hideNotAvailableProducts}
          />
        ) : (
          categories.items.map(category => (
            <Category
              key={category._id}
              category={category}
              setSelectedCategoryId={setSelectedCategoryId}
              storeId={storeId}
              deliverAt={deliverAt}
              menuId={menuId}
              hideNotAvailableProducts={hideNotAvailableProducts}
            />
          ))
        )}
      </Container>
    </div>
  )
}
